import { ESCALA } from "../tema";
import { estiloRotulo, formatterValor, montarSeries, opcoesBase } from "./base";

/**
 * Família 3 — ranking em cilindros 3D.
 *
 * Uma série só, um cilindro por item, valor em caixa acima e o nome do
 * item embaixo. É o modelo do "Ranking Leite ao Produtor": serve para
 * comparar poucos itens (tipicamente 5 UFs) com destaque visual.
 *
 * Diferente da família 1, aqui não há legenda nem parede de fundo — o
 * cilindro fica sobre o preto.
 */
const modelo = {
  id: "cilindro-ranking",
  label: "Cilindro 3D (ranking)",
  descricao: "Cilindros em perspectiva, um por item. Ex.: ranking de preço por UF.",

  build(spec) {
    const base = opcoesBase(spec);

    return {
      ...base,
      chart: {
        ...base.chart,
        type: "cylinder",
        marginBottom: 20 * ESCALA,
        options3d: {
          enabled: true,
          alpha: 14,
          beta: 0,
          depth: 46,
          viewDistance: 30,
          frame: {
            bottom: { size: 0, color: "transparent" },
            back: { size: 0, color: "transparent" },
            side: { size: 0, color: "transparent" },
            top: { size: 0, color: "transparent" },
          },
        },
      },
      xAxis: {
        ...base.xAxis,
        categories: spec.dados?.categorias || [],
        lineWidth: 0,
      },
      yAxis: { ...base.yAxis, maxPadding: 0.16 },
      plotOptions: {
        ...base.plotOptions,
        series: {
          ...base.plotOptions.series,
          borderWidth: 0,
          groupPadding: 0.06,
          pointPadding: 0,
          depth: 46,
          dataLabels: {
            ...estiloRotulo(spec),
            formatter: formatterValor(spec),
          },
        },
      },
      series: montarSeries(spec, { showInLegend: false }),
    };
  },

  exemplo() {
    return {
      modelo: "cilindro-ranking",
      titulo: [
        { texto: "Ranking ", cor: "#FFFFFF" },
        { texto: "Leite ao Produtor", cor: "#F0F000" },
        { texto: " - Brasil", cor: "#FFFFFF" },
      ],
      subtitulo: [{ texto: "Janeiro a Julho 2026 - (R$/l)", cor: "#00D0FF" }],
      fonte: "Fonte: RURAL BUSINESS/CEPEA",
      fundo: "#000000",
      fundoPlot: "nenhum",
      dados: {
        categorias: ["MG", "SP", "PR", "RJ", "GO"],
        series: [
          {
            nome: "Preço",
            cor: "#3FA9F5",
            corFim: "#0B3C6B",
            valores: [2.593, 2.556, 2.541, 2.476, 2.47],
          },
        ],
      },
      legenda: { visivel: false },
      // Base cortada em 2,30: sem isso os cinco cilindros ficam do mesmo
      // tamanho e o ranking deixa de se ler.
      eixo: { min: 2.3, max: null },
      valores: { decimais: 3, prefixo: "", sufixo: "", exibirEm: "todos" },
      rotulo: { corTexto: "#FFFFFF", corFundo: "#1A1A1A", corBorda: "#FFFFFF" },
      extras: { formato: "cilindro" },
    };
  },
};

export default modelo;
